import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Company/Main";
import Form from "./Company/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDataEmployee } from "../../../model/InitialData/InitialDataEmployee";

const Company = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataEmpPosition, setDataEmpPosition] = useState([]);
  const [dataEmpDept, setDataEmpDept] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataEmployee());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getData(
        "Tb_Set_Company",
        "1 = 1 Order By Comp_Id"
      );
      const dataPosition = await getData("Tb_Set_Position", "1=1");
      const dataDept = await getData("Tb_Set_Dept", "1=1");
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
      if (dataPosition && dataPosition.length > 0) {
        setDataEmpPosition(dataPosition);
      }

      if (dataDept && dataDept.length > 0) {
        setDataEmpDept(dataDept);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      Comp_Id: item.Comp_Id,
      Comp_Code: item.Comp_Code,
      Comp_Name_TH: item.Comp_Name_TH,
      Comp_Name_EN: item.Comp_Name_EN,
      Comp_ShortName: item.Comp_ShortName,
      Comp_TaxNo: item.Comp_TaxNo,
      Comp_Add1: item.Comp_Add1,
      Comp_Add2: item.Comp_Add2,
      Comp_Add3: item.Comp_Add3,
      Comp_Province: item.Comp_Province,
      Comp_Post: item.Comp_Post,
      Comp_Tel1: item.Comp_Tel1,
      Comp_Tel2: item.Comp_Tel2,
      Comp_Contact1: item.Comp_Contact1,
      Comp_Contact2: item.Comp_Contact2,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลบริษัท"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลบริษัท"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataEmpPosition={dataEmpPosition}
                  dataEmpDept={dataEmpDept}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
